import {Component, inject} from '@angular/core';
import { Router } from '@angular/router';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
@Component({
    selector: 'system-list-hub',
    templateUrl: './system-list-hub.component.html',
    standalone: false
})
export class SystemListHubComponent {
  router = inject(Router)
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }]

  organizationClick() {
    this.router.navigate(['dashboard/SystemManagement/organizations'])
  }

  subjectClick() {
    this.router.navigate(['dashboard/SystemManagement/subjects'])
  }

  unitClick()  {
    this.router.navigate(['dashboard/SystemManagement/units'])
  }

  courseClick() {
    this.router.navigate(['dashboard/SystemManagement/courses'])
  }

  protected readonly faChevronRight = faChevronRight;
}
